package com.patronat.top.features.usermanagement.data.mappers

import com.patronat.top.core.domain.models.profiles.User
import com.patronat.top.core.domain.models.profiles.UserFilter
import com.patronat.top.dto.CreateUserRequest
import com.patronat.top.dto.GetUsersRequest
import com.patronat.top.dto.ProfileListResponse
import com.patronat.top.dto.ProfileSuccessResponse
import com.patronat.top.dto.UpdateUserRequest
import com.patronat.top.features.usermanagement.domain.models.FilteredUsers
import com.patronat.top.features.usermanagement.domain.models.UserStatus
import com.patronat.top.dto.UserStatus as DtoStatus


fun ProfileListResponse.toDomain() : FilteredUsers {
     return FilteredUsers(
        items = this.items.map { it.toDomain() },
        totalCount = this.totalCount,
        page = this.page,
        pageSize = this.pageSize
    )
}


fun ProfileSuccessResponse.toDomain(): User {
    return User(
        id = this.id,
        firstName = this.firstName,
        lastName = this.lastName,
        email = this.email ?: "",
        phone = this.phone,
        role = this.role,
        status = this.status,
        isPhoneVerified = this.isPhoneVerified,
        isEmailVerified = this.isEmailVerified,
        createdAt = this.createdAt,
        avatarUrl = this.avatarUrl,
        avatarMediaId = this.avatarMediaId,
    )
}


fun UserFilter.toRequest(): GetUsersRequest{
    return GetUsersRequest(
        page = this.page,
        pageSize = this.pageSize,
        query = this.query,
        roles = this.roles,
        statuses = this.statuses,
        ownerId = this.ownerId,
    )
}

fun User.toCreateUserRequest(): CreateUserRequest {
    return CreateUserRequest(
        firstName = this.firstName,
        lastName = this.lastName,
        email = this.email,
        phone = this.phone,
        role = this.role,
        avatarUrl = this.avatarUrl,
        avatarMediaId = this.avatarMediaId,
    )
}

fun User.toUpdateUserRequest(): UpdateUserRequest {
    return UpdateUserRequest(
        firstName = this.firstName,
        lastName = this.lastName,
        email = this.email,
        phone = this.phone,
        status = this.status,
        avatarUrl = this.avatarUrl,
        avatarMediaId = this.avatarMediaId,
    )
}




fun DtoStatus.toDomain(): UserStatus {
    return when (this) {
        DtoStatus.ACTIVE -> UserStatus.ACTIVE
        DtoStatus.DEACTIVATED -> UserStatus.INACTIVE
        DtoStatus.BLOCKED -> UserStatus.INACTIVE
        DtoStatus.UNAUTHORIZED -> UserStatus.INACTIVE
    }
}

fun UserStatus.toDto(): DtoStatus {
    return when (this) {
        UserStatus.ACTIVE -> DtoStatus.ACTIVE
        UserStatus.INACTIVE -> DtoStatus.DEACTIVATED
    }
}

